import Common from '../wp-controlers/common-panel/geralAttributes';

export default {
  title: {
    type: 'string',
    default: 'Informe o título da seção',
  },
  subtitle: {
    type: 'string',
    default: '',
  },
  hasSubtitle: {
    type: 'boolean',
    default: false,
  },
  textPosition: {
    type: 'string',
    default: '',
  },
  btnText: {
    type: 'string',
    default: 'Me Ligue',
  },
  formId: {
    type: 'string',
    default: '2',
  },
  ...Common,
};
